import React from 'react'

export default function Index() {
  return (
    <div>Publish Page</div>
  )
}
